import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import {ThemeConfig} from "./dataTypes/ThemeConfig";

const ThemedApp = ({ themeConfig, children }: { themeConfig: ThemeConfig | null, children: React.ReactNode }) => {
    const theme = createTheme({
        palette: {
            primary: {
                main: themeConfig?.color || '#1976d2',
            },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default ThemedApp;
